// BJT 第2部 聴読解部門 题库
// 共 60 题，覆盖三种题型：状況把握問題、資料聴読解問題、総合聴読解問題

// ─────────────────────────────────────────
// Section 1：状況把握問題 Q1~Q20
// ─────────────────────────────────────────

const Q1 = {
  id: 1,
  number: '1番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：二人の社員が話しています',
  scene: '展示会の準備について相談',
  audioScript: '男：田中さん、来月の展示会の準備はどうなってますか。\n女：はい、会場の予約は完了しました。ただ、パンフレットのデザインがまだ決まっていなくて。\n男：そうか。デザイン会社への発注はいつまでに必要ですか。\n女：今週中に決めないと間に合わないそうです。\n男：じゃあ、午後に打ち合わせをしましょうか。サンプルを何案か持ってきてください。',
  question: '二人は主に何について相談していますか。',
  options: ['展示会の会場選び', 'パンフレットのデザイン', '展示会の参加者数', '発注業者の変更'],
  answer: 1,
  explanation: '会話の中心は「パンフレットのデザインがまだ決まっていない」という問題であり、今週中に決定しなければならないと述べられています。会場はすでに予約済みです。',
};

const Q2 = {
  id: 2,
  number: '2番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：三人の社員が話しています',
  scene: '在庫管理システムの問題',
  audioScript: '女A：さっきから在庫システムがおかしくて、注文が入っているのに在庫数がゼロと表示されるんです。\n男：本当に？それは困ったね。お客様への出荷はどうするの。\n女B：倉庫に確認したら実際の在庫はありました。システムのデータが更新されていないようです。\n男：IT部門に連絡して、すぐに修正してもらわないと。今日の出荷に間に合うかな。\n女A：さっき連絡しました。30分以内に対応してくれるそうです。',
  question: '何についての問題ですか。',
  options: ['在庫管理システムのエラー', '倉庫の在庫不足', 'お客様のキャンセル', 'IT部門の人員不足'],
  answer: 0,
  explanation: '実際の在庫はあるものの、在庫システムのデータが更新されていないため、ゼロと表示されてしまうというシステムエラーが問題です。',
};

const Q3 = {
  id: 3,
  number: '3番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：上司と部下が話しています',
  scene: 'プレゼン資料の準備',
  audioScript: '上司：山本さん、明日の取引先へのプレゼン資料、できましたか。\n部下：はい、スライドは完成しました。ただ最新の売上データをまだ入れていません。\n上司：それは必ず入れてください。あと、配布用の印刷は？\n部下：まだです。データを更新してから印刷します。\n上司：了解。今日中に終わらせてください。',
  question: '部下はこのあと、まず何をしますか。',
  options: ['スライドを最初から作り直す', '売上データを資料に追加する', '資料を印刷する', '取引先に連絡する'],
  answer: 1,
  explanation: '部下は「データを更新してから印刷する」と述べており、まず最新売上データを追加し、その後印刷する順番です。',
};

const Q4 = {
  id: 4,
  number: '4番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：電話での会話',
  scene: '商品納期遅延の連絡',
  audioScript: '男：もしもし、ABCトレーディングの佐藤と申します。先日ご注文いただいた商品の件でご連絡しました。\n女：はい、どのような件でしょうか。\n男：実は、ご注文いただいた商品の一部が現在欠品となっておりまして、納期が当初の予定より一週間ほど遅れる見込みです。\n女：そうですか。どの商品が欠品なのか教えていただけますか。\n男：品番A-203の商品です。大変ご迷惑をおかけして申し訳ございません。',
  question: '電話をかけた目的は何ですか。',
  options: ['新商品の注文を受けるため', '代金の支払いを確認するため', '納期の遅延を知らせるため', '注文内容の変更を依頼するため'],
  answer: 2,
  explanation: '欠品により納期が一週間ほど遅れることを顧客に知らせるために電話しています。',
};

const Q5 = {
  id: 5,
  number: '5番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：会議室での会話',
  scene: 'オフィス移転の決定',
  audioScript: '部長：新しいオフィス移転の件ですが、A案とB案、どちらにしますか。\n社員A：A案は広さは十分ですが、駅から遠いのが心配です。\n社員B：B案は駅近ですが、賃料がかなり高いですよね。\n部長：営業部のみなさんは外回りが多いので、駅近の方が便利でしょう。コストは少し高くても。\n社員A：確かに。では、B案で進めましょう。\n部長：では、B案に決定ということで。不動産会社に連絡してください。',
  question: '会議の結果、どうなりましたか。',
  options: ['A案（広いオフィス）に決まった', 'B案（駅近のオフィス）に決まった', 'どちらの案も採用しないことになった', '決定を来週に持ち越した'],
  answer: 1,
  explanation: '部長が営業部の外回りを考慮してB案（駅近・高賃料）を推し、「B案に決定」と述べています。',
};

const Q6 = {
  id: 6,
  number: '6番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：二人が話しています',
  scene: '経費精算システムの使い方',
  audioScript: '女：すみません、ちょっとよろしいですか。新しい経費精算システムの使い方がよくわからなくて。\n男：あ、私も最初は戸惑いました。どこでつまずいていますか。\n女：領収書の写真を添付しようとするんですが、うまくアップロードできないんです。\n男：ファイルの形式はJPEGかPDFですか？他の形式は対応していないんですよ。\n女：あ、PNGで保存していました。それが原因かも。ありがとうございます。',
  question: '女の人は何に困っていましたか。',
  options: ['経費精算の承認が降りない', '領収書をなくしてしまった', '領収書の写真をアップロードできない', 'システムにログインできない'],
  answer: 2,
  explanation: '女性はPNG形式のファイルをアップロードしようとしていましたが、システムはJPEGまたはPDFのみ対応しているため、アップロードができなかったのが原因です。',
};

const Q7 = {
  id: 7,
  number: '7番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：社員と顧客が話しています',
  scene: '新サービスの説明',
  audioScript: '社員：本日はお忙しい中、お越しいただきありがとうございます。新サービスのご説明をさせてください。\n顧客：はい、でも正直なところ、今のサービスで特に不満はないんですよね。\n社員：そうですか。新サービスでは月額コストを20%削減できます。\n顧客：20%ですか。それは魅力的ですね。詳しく聞かせてもらえますか。\n社員：はい、まずコスト削減の仕組みからご説明します。',
  question: '顧客の気持ちの変化として正しいものはどれですか。',
  options: ['最初から積極的で、さらに期待が高まった', '最初から拒否的で、最後まで興味を示さなかった', '最初は消極的だったが、コスト削減の話で興味を持ち始めた', '最初は興味があったが、説明を聞いて不安になった'],
  answer: 2,
  explanation: '顧客は最初「今のサービスで不満はない」と消極的でしたが、20%のコスト削減という説明を聞いて「詳しく聞かせてもらえますか」と前向きになりました。',
};

const Q8 = {
  id: 8,
  number: '8番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：部署内での会話',
  scene: '経営会議の出席者決定',
  audioScript: '課長：明日の10時から経営会議があります。営業部からは2名出席してもらいます。\n社員A：私は明日、客先の訪問があって参加できません。\n社員B：私は大丈夫です。\n課長：では、鈴木さん、もう一人どうですか。\n社員C：私も参加可能です。ただ、途中で別の打ち合わせがあるので11時には退席します。\n課長：わかりました。鈴木さんと田中さんで、よろしくお願いします。',
  question: '経営会議に出席するのは誰ですか。',
  options: ['社員Aと社員B', '社員Aと社員C', '社員Aと課長', '社員Bと社員C（鈴木さんと田中さん）'],
  answer: 3,
  explanation: '社員Aは客先訪問があるため不参加。課長が「鈴木さんと田中さん」（社員Bと社員C）に出席を依頼しました。',
};

const Q9 = {
  id: 9,
  number: '9番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：社内での会話',
  scene: '上司と部下の関係',
  audioScript: '男：林さん、今週の売上レポート、まだ提出していませんが。締め切りは昨日でしたよ。\n女：申し訳ありません。別の案件が重なってしまいまして。今日の午後には必ず出します。\n男：わかりました。でも次回からは締め切りを守るようにしてください。\n女：はい、気をつけます。ご迷惑をおかけして申し訳ありません。\n男：了解です。午後に届けばいいですから。',
  question: '二人はどのような関係だと思われますか。',
  options: ['上司と部下', '同僚', '取引先の担当者', '新入社員と先輩'],
  answer: 0,
  explanation: '男性が女性に対して「締め切りを守るように」と指示し、女性が「申し訳ありません」と謝っている言葉遣いから、上司と部下の関係が読み取れます。',
};

const Q10 = {
  id: 10,
  number: '10番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：社内での廊下会話',
  scene: '社員証システム変更の周知',
  audioScript: '男：松田さん、さっき総務から連絡があって、来月から社員証のIDカードシステムが変わるらしいですよ。\n女：えっ、そうなんですか。何か手続きが必要ですか。\n男：全員が新しいカードに切り替えないといけないらしくて、でも連絡がまだ一部の人にしか届いていないらしくて。\n女：それは困りましたね。みんなに伝わっていないと、手続きが間に合わない人が出てきますよね。\n男：総務が全員に周知メールを送ってくれると言っていましたが、まだ来ていないですよね。',
  question: '何が問題として挙げられていますか。',
  options: ['IDカードシステムの変更に費用がかかること', '変更の周知が全員に届いていないこと', '新しいシステムの操作が複雑なこと', 'カードの切り替え期間が短すぎること'],
  answer: 1,
  explanation: '「連絡がまだ一部の人にしか届いていない」「みんなに伝わっていないと手続きが間に合わない人が出る」という発言から、周知不足が問題です。',
};

const Q11 = {
  id: 11,
  number: '11番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：ビジネス会食の場面',
  scene: '契約終了後の関係継続',
  audioScript: '男A：本日はお忙しい中、お越しいただきありがとうございます。\n男B：いえいえ、こちらこそ。今回の5年間の契約期間が無事終わって、御社には大変お世話になりました。\n男A：おかげさまで、共同プロジェクトも大きな成果を上げることができました。\n男B：ぜひ今後も良いパートナーシップを続けていきたいと思っています。\n男A：もちろんです。では来年度の協力関係について、今日はざっくばらんに話しましょう。',
  question: 'この会食の目的は何ですか。',
  options: ['新規取引の交渉', 'プロジェクトの問題解決', '契約終了後の今後の関係について話し合う', '取引の打ち切りを伝える'],
  answer: 2,
  explanation: '5年間の契約が終わったことへの感謝と、今後も良いパートナーシップを続けるための来年度の協力関係について話し合うための会食です。',
};

const Q12 = {
  id: 12,
  number: '12番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：電話での会話',
  scene: '請求書の数量誤り',
  audioScript: '社員：はい、山田商事営業部でございます。\n相手：お世話になっております。先月ご注文させていただいた商品について確認させていただきたいことがあって。\n社員：はい、どのようなことでしょうか。\n相手：請求書が届いたんですが、数量が注文書と違っているようで。50個のご注文だったのに、請求書に100個と記載されています。\n社員：ご迷惑をおかけして申し訳ありません。すぐに確認して訂正した請求書をお送りします。',
  question: '電話をかけてきたのは誰ですか。',
  options: ['社内の別の部署の社員', '商品を注文した顧客', '新規取引を希望する会社', '配送業者'],
  answer: 1,
  explanation: '「先月ご注文させていただいた」「ご注文だったのに」という言葉から、注文した顧客が請求書の数量誤りについて問い合わせていることがわかります。',
};

const Q13 = {
  id: 13,
  number: '13番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：会議での会話',
  scene: '新製品発売時期の決定',
  audioScript: '部長：新製品の発売時期ですが、当初の計画では4月でしたね。\n開発担当：はい。ただ、品質テストでいくつかの問題が見つかりまして、修正に2ヶ月ほどかかる見込みです。\n部長：そうですか。競合他社が3月に類似品を出すという情報もありますし、難しいところですね。\n営業担当：市場への影響を考えると、6月に延期しても問題ないと考えます。品質を優先すべきかと。\n部長：わかりました。品質を優先して6月の発売としましょう。',
  question: '新製品はいつ発売されることになりましたか。',
  options: ['当初の計画通り4月', '競合に対抗して3月', '品質修正後の6月', 'さらに検討が必要で未定'],
  answer: 2,
  explanation: '品質テストの問題修正に2ヶ月かかるため、品質を優先して6月発売に変更することが決定されました。',
};

const Q14 = {
  id: 14,
  number: '14番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：同僚二人の昼食時会話',
  scene: '新入社員定着率の問題',
  audioScript: '女：最近、新入社員の定着率が低いって課長が言っていましたね。\n男：そうですね。入社後6ヶ月以内に辞めてしまう人が増えているみたいで。\n女：メンター制度を導入してみてはどうでしょう。先輩社員が新人一人一人をサポートする仕組みです。\n男：確かに、入社初期の孤独感が問題だと思っていました。費用はかかりますか。\n女：既存社員がメンターになるので、追加コストはほとんどないと思います。',
  question: '女性はどんな提案をしていますか。',
  options: ['新入社員の採用基準を見直す', '先輩社員が新人をサポートするメンター制度の導入', '給与水準の引き上げ', '研修期間の延長'],
  answer: 1,
  explanation: '女性は「メンター制度を導入してみてはどうでしょう」と提案し、先輩社員が新人一人一人をサポートする仕組みだと説明しています。',
};

const Q15 = {
  id: 15,
  number: '15番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：上司と部下の会話',
  scene: '訪問先での報告',
  audioScript: '部下：課長、今日の訪問の報告をしてもよろしいでしょうか。\n課長：はい、どうぞ。\n部下：ABC社の担当者と面談しましたが、今期は予算の都合で新規購入は難しいとのことでした。\n課長：そうか。来期はどうだろう。\n部下：来期については検討すると言っていました。定期的にフォローすれば受注の可能性はあると思います。\n課長：わかった。継続してアプローチしてください。',
  question: '部下はABC社について何を報告していますか。',
  options: ['今期は購入できないが、来期は可能性がある', 'すでに注文を受けた', '競合他社の製品を選んだ', '担当者が不在で面談できなかった'],
  answer: 0,
  explanation: '今期は予算の都合で新規購入困難、来期は検討するとの報告であり、継続フォローで受注の可能性があるという内容です。',
};

const Q16 = {
  id: 16,
  number: '16番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：朝のオフィスでの会話',
  scene: '会議スケジュールの変更',
  audioScript: '男：今日は午後から全社会議でしたよね。\n女：あ、それが変更になりました。社長が急用で明日に延期されたんです。\n男：そうですか。じゃあ今日の午後は空いたわけですね。\n女：そうなんですが、代わりに部長から部内ミーティングを入れると連絡がありました。\n男：何時からですか。\n女：15時からです。それまでは各自の業務を進めてくださいとのことです。',
  question: '今日の午後のスケジュールはどうなりましたか。',
  options: ['予定通り全社会議がある', '全社会議がなくなり、一日中自由時間になった', '全社会議が午前中に変更された', '全社会議が延期され、15時から部内ミーティングになった'],
  answer: 3,
  explanation: '全社会議は明日に延期、代わりに15時から部内ミーティングが入りました。それまでは各自業務とのことです。',
};

const Q17 = {
  id: 17,
  number: '17番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：二人が社内文書について話しています',
  scene: '提案書のチェック',
  audioScript: '女：田中さん、この提案書なんですが、数字の単位が途中から万円表示になっていて、最初は円表示なんですよ。\n男：あ、本当ですね。読む人が混乱しますね。\n女：それと、3ページ目の表にデータが抜けている箇所があります。\n男：それは修正が必要ですね。あと誤字もいくつかあるように見えますが。\n女：そうですね。明日の提出前に全部直した方がいいです。',
  question: '提案書の問題点として挙げられていないものはどれですか。',
  options: ['数字の単位が統一されていない', '表のデータが抜けている', '誤字がある', 'ページ数が多すぎる'],
  answer: 3,
  explanation: '会話で挙げられた問題は①単位の不統一、②データの欠落、③誤字の3つです。ページ数については言及されていません。',
};

const Q18 = {
  id: 18,
  number: '18番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：研修終了後の会話',
  scene: '交渉スキル研修の感想',
  audioScript: '女A：今日の交渉スキル研修、いかがでしたか。\n男：ロールプレイングが特によかったですね。実際の場面を想定して練習できました。\n女B：私も同感です。ただ、もう少し時間があればよかったかな。かなり駆け足でしたよね。\n男：確かに。でも内容自体はとても役立ちそうです。明日からの商談に使えそうなテクニックを学べました。\n女A：よかった。次回はもう少しゆっくり進められるように調整しますね。',
  question: '参加者の研修に対する意見として正しいものはどれですか。',
  options: ['内容が難しすぎてついていけなかった', 'ロールプレイングは不要だと感じた', '内容は良かったが、時間が短かった', '実務にはあまり役立たない'],
  answer: 2,
  explanation: 'ロールプレイングは良く、内容も役立つとの評価でしたが、「もう少し時間があればよかった」「駆け足でした」という声があり、時間不足が共通の意見でした。',
};

const Q19 = {
  id: 19,
  number: '19番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：会社の受付での会話',
  scene: '採用面接の打ち合わせ',
  audioScript: '受付：いらっしゃいませ。本日はどのようなご用件でしょうか。\n来客：株式会社グローバルテックの木村と申します。本日、御社の人事部の中村様とお約束をしておりまして。\n受付：木村様でいらっしゃいますね。少々お待ちくださいませ。中村に連絡いたします。\n来客：ありがとうございます。採用面接についての打ち合わせでお伺いしました。\n受付：はい、承知いたしました。こちらのソファでしばらくお待ちください。',
  question: '木村さんは何のために来社しましたか。',
  options: ['商品の納品のため', '採用面接についての打ち合わせのため', '就職面接を受けるため', '人事部への応募書類を届けるため'],
  answer: 1,
  explanation: '木村さんは「採用面接についての打ち合わせ」のために来社したと明言しており、人事部の中村さんとアポイントがあります。',
};

const Q20 = {
  id: 20,
  number: '20番',
  type: 'listening',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '状況把握：二人の社員が話しています',
  scene: '顧客満足度調査の結果',
  audioScript: '男：今月の顧客満足度調査の結果が出たんですが、スコアが先月より5ポイント下がっています。\n女：そうですか。自由回答欄に何か書かれていましたか。\n男：「電話の対応が冷たい」「担当者によって説明が違う」という声が多かったです。\n女：なるほど。応対の質にばらつきがあるということですね。\n男：はい。接客トレーニングを強化する必要がありますね。\n女：マニュアルの見直しも必要かもしれません。',
  question: '顧客満足度が下がった主な原因は何ですか。',
  options: ['商品の品質が低下した', '価格が高くなった', '電話応対や説明の質にばらつきがある', '配送が遅れている'],
  answer: 2,
  explanation: '「電話の対応が冷たい」「担当者によって説明が違う」という顧客の声から、応対の質にばらつきがあることが主な原因です。',
};

// ─────────────────────────────────────────
// Section 2：資料聴読解問題 Q21~Q40
// ─────────────────────────────────────────

const Q21 = {
  id: 21,
  number: '21番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：売上比率グラフ',
  scene: '事業部門別売上分析',
  audioScript: 'このグラフは、当社の4つの事業部門の今年度の売上比率を示しています。IT事業部が最も大きく全体の約4割を占め、次いで製造部門が3割、サービス部門が2割、その他が1割となっています。前年度と比較すると、IT事業部の割合が5ポイント増加しています。',
  material: {
    type: 'table',
    title: '売上比率グラフ（今年度）',
    content: [
      ['部門', '今年度', '前年度'],
      ['IT事業部', '40%', '35%'],
      ['製造部門', '30%', '32%'],
      ['サービス部門', '20%', '22%'],
      ['その他', '10%', '11%']
    ]
  },
  question: 'IT事業部の今年度の変化として正しいものはどれですか。',
  options: ['前年度より割合が減少した', '前年度より割合が5ポイント増加した', '全体の半分以上を占めている', '前年度と変化がない'],
  answer: 1,
  explanation: '表よりIT事業部は前年度35%から今年度40%へ、5ポイント増加しています。全体の4割であり、半分以上ではありません。',
};

const Q22 = {
  id: 22,
  number: '22番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：広告分析',
  scene: '水道設備業者の広告',
  audioScript: '次の広告はどのような企業が出したものか考えてください。広告には「緊急対応24時間・水道管修理・排水口つまり解消・給湯器交換」などのサービスが記載されています。また「出張費無料・見積り無料」と書かれており、電話番号と地域名が大きく記載されています。',
  material: {
    type: 'ad',
    title: '広告',
    content: '水回りのトラブル、即解決！\n緊急対応 24時間365日\n✓ 水道管の修理・交換\n✓ 排水口・トイレのつまり解消\n✓ 給湯器の修理・交換\n✓ 蛇口・シャワーの交換\n出張費無料 ／ お見積り無料\n☎ 0120-XXX-XXX\n横浜市・川崎市・相模原市 対応エリア'
  },
  question: 'この広告を出した企業はどのような業者ですか。',
  options: ['電気工事会社', '不動産会社', '水道・設備工事業者', '家電量販店'],
  answer: 2,
  explanation: '水道管修理、排水口つまり、給湯器交換など、すべて水回りの設備に関するサービスが記載されており、水道・設備工事業者の広告です。',
};

const Q23 = {
  id: 23,
  number: '23番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：気温変化データ',
  scene: '都市の気温変化分析',
  audioScript: 'このグラフは、ある都市の10年間の平均気温の変化を示しています。10年前と比べて年間平均気温が1.5度上昇しています。特に夏の最高気温が上昇しており、猛暑日（35度以上）の日数が10年前の2倍になっています。冬の気温については大きな変化は見られません。',
  material: {
    type: 'table',
    title: '気温変化データ（10年比較）',
    content: [
      ['項目', '10年前', '現在'],
      ['年間平均気温', '14.2℃', '15.7℃'],
      ['夏の最高気温（平均）', '31.5℃', '33.8℃'],
      ['猛暑日数（年間）', '15日', '30日'],
      ['冬の最低気温（平均）', '2.1℃', '2.3℃']
    ]
  },
  question: 'グラフから読み取れる正しい情報はどれですか。',
  options: ['冬の気温が10年前より大幅に低下した', '猛暑日数は10年前から変わっていない', '夏の最高気温は低下している', '猛暑日数が10年前の2倍になった'],
  answer: 3,
  explanation: '猛暑日数は10年前15日から現在30日へと2倍になっています。冬の気温はほぼ変化なし、夏は上昇、年間平均も上昇しています。',
};

const Q24 = {
  id: 24,
  number: '24番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：教室チラシ',
  scene: 'シニア向けスマートフォン教室',
  audioScript: 'このチラシについて、「どのような人を対象としたサービスですか」という質問に答えてください。チラシには「シニアのための安心スマートフォン教室」「60歳以上対象」「スマホの基本操作から始めます」「ご家族への連絡方法・写真の撮り方・地図の使い方」などの記載があります。',
  material: {
    type: 'ad',
    title: '教室チラシ',
    content: 'シニアのための安心スマートフォン教室\n📌 60歳以上の方が対象です\n◆ スマホの基本操作（電話・文字入力）\n◆ ご家族へのメッセージ・通話\n◆ 写真の撮り方・送り方\n◆ 地図アプリの使い方\n◆ 迷惑電話・詐欺の見分け方\n月2回・無料体験あり　定員各回10名'
  },
  question: 'このチラシが対象としている人はどのような人ですか。',
  options: ['スマートフォンの使い方に不慣れな高齢者', 'スマートフォンの販売員', '子どものスマートフォン利用を心配する保護者', 'スマートフォンアプリの開発者'],
  answer: 0,
  explanation: '「60歳以上対象」「基本操作から始める」という記載から、スマートフォンの操作に慣れていない高齢者向けのサービスであることがわかります。',
};

const Q25 = {
  id: 25,
  number: '25番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：在宅勤務実施率',
  scene: '企業在宅勤務調査',
  audioScript: 'このグラフは、ある会社の在宅勤務実施率の変化を示しています。コロナ前は10%、コロナ禍のピーク時は75%、現在は45%となっています。現在の水準はコロナ前と比べて大幅に高く、完全に元に戻った企業は少ないことがわかります。',
  material: {
    type: 'chart',
    title: '在宅勤務実施率の変化',
    content: [
      ['コロナ前', '10%'],
      ['ピーク時', '75%'],
      ['現在', '45%']
    ]
  },
  question: '現在の在宅勤務実施率について正しい説明はどれですか。',
  options: ['コロナ前と同じ水準に戻っている', 'ピーク時よりも高くなっている', 'コロナ前より高いが、ピーク時より低い', '全ての企業で在宅勤務がなくなった'],
  answer: 2,
  explanation: '現在45%は、コロナ前10%より高く、ピーク時75%より低い位置にあります。',
};

const Q26 = {
  id: 26,
  number: '26番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：求人広告',
  scene: '営業事務スタッフ募集',
  audioScript: 'この求人広告を見て、応募するために必要な条件は何か考えてください。広告には仕事内容、応募資格、待遇が記載されています。',
  material: {
    type: 'ad',
    title: '求人広告',
    content: '【正社員募集】営業事務スタッフ\n仕事内容：受発注管理・請求書作成・顧客対応\n勤務地：東京都港区（最寄：青山一丁目）\n給与：月給22万円〜（経験考慮）\n勤務時間：9:00〜18:00（残業少なめ）\n必須要件：Word・Excel基本操作／日本語ビジネスメール\n歓迎：営業事務経験1年以上・英語力\n待遇：社保完備・交通費全額支給・年2回賞与'
  },
  question: 'この求人に応募するために必ず必要な条件はどれですか。',
  options: ['Word・Excelの基本操作とビジネスメールの能力', '英語力', '営業事務の経験1年以上', '大学卒業以上の学歴'],
  answer: 0,
  explanation: '「必須要件」に明記されているのはWord・Excel基本操作と日本語ビジネスメールのみです。英語力と営業事務経験は「歓迎」条件（必須ではない）です。',
};

const Q27 = {
  id: 27,
  number: '27番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：店舗数推移',
  scene: '飲食チェーンの店舗展開',
  audioScript: 'このグラフは、ある飲食チェーンの店舗数の推移を示しています。5年前は50店舗でしたが、毎年20店舗ずつ増加しており、現在は150店舗になっています。来年はさらに30店舗を出店する計画があります。',
  material: {
    type: 'table',
    title: '店舗数推移',
    content: [
      ['年度', '店舗数', '増減'],
      ['5年前', '50店', '—'],
      ['4年前', '70店', '+20'],
      ['3年前', '90店', '+20'],
      ['2年前', '110店', '+20'],
      ['1年前', '130店', '+20'],
      ['現在', '150店', '+20'],
      ['来年（計画）', '180店', '+30']
    ]
  },
  question: '来年の店舗数は何店舗になる予定ですか。',
  options: ['150店舗', '160店舗', '170店舗', '180店舗'],
  answer: 3,
  explanation: '現在150店舗に、来年は30店舗を出店する計画なので150＋30＝180店舗になります。',
};

const Q28 = {
  id: 28,
  number: '28番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：システムメンテナンスのお知らせ',
  scene: '社内システムメンテナンス',
  audioScript: 'このお知らせには、社内システムのメンテナンスに関する重要な情報が含まれています。メンテナンス中は一部のサービスが利用できなくなります。',
  material: {
    type: 'notice',
    title: 'システムメンテナンスのお知らせ',
    content: '下記の日程で社内システムのメンテナンスを実施いたします。\n実施日時：2024年3月15日（金）20:00〜翌3:00\n影響範囲：給与システム・経費精算システム・人事システム\n利用不可：上記3システムへのアクセス不可\n影響なし：メール・チャットツール・ファイル共有は通常通り\n※ご不明な点はシステム管理部（内線：1234）までお問い合わせください。'
  },
  question: 'メンテナンス中も使用できるものはどれですか。',
  options: ['給与システム', '経費精算システム', '人事システム', 'メール・チャットツール'],
  answer: 3,
  explanation: '「影響なし」に明記されているメール・チャットツール・ファイル共有は通常通り使用できます。給与・経費精算・人事システムはアクセス不可です。',
};

const Q29 = {
  id: 29,
  number: '29番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：社員ストレス原因調査',
  scene: '社員ストレス調査結果',
  audioScript: 'このグラフは、社員がストレスを感じる原因のランキングです。最も多い回答は「業務量が多い」で45%、次いで「上司との関係」が30%、「将来への不安」が15%、「給与への不満」が10%となっています。',
  material: {
    type: 'table',
    title: '社員ストレス原因調査（複数回答不可）',
    content: [
      ['順位', 'ストレスの原因', '回答率'],
      ['1位', '業務量が多い', '45%'],
      ['2位', '上司との関係', '30%'],
      ['3位', '将来への不安', '15%'],
      ['4位', '給与への不満', '10%']
    ]
  },
  question: 'この調査の結果について正しい説明はどれですか。',
  options: ['最大のストレス原因は仕事量の多さである', '給与への不満が最も多くの社員に影響している', '人間関係より給与の問題を重視する社員が多い', '将来への不安を感じている社員は全体の1%未満'],
  answer: 0,
  explanation: '1位の「業務量が多い」が45%と最も高く、最大のストレス原因です。給与への不満は4位（10%）で最低です。',
};

const Q30 = {
  id: 30,
  number: '30番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：会社案内',
  scene: '物流会社の事業内容',
  audioScript: 'この会社案内から、どのような事業を行っている会社か読み取ってください。主要なキーワードや事業内容の記載に注目しましょう。',
  material: {
    type: 'profile',
    title: '会社案内（一部抜粋）',
    content: '株式会社フューチャーロジスティクス　会社概要\n創業：1998年\n資本金：5億円\n従業員数：850名（グループ全体）\n主要事業：貨物輸送・倉庫管理・3PL（物流一括請負）\n保有車両：大型トラック120台・小型車両300台\n倉庫面積：合計15万㎡（全国8拠点）'
  },
  question: 'この会社はどのような業種ですか。',
  options: ['製造業', '物流・輸送業', '情報通信業', '小売業'],
  answer: 1,
  explanation: '「貨物輸送・倉庫管理・3PL（物流一括請負）」が主要事業であり、トラックや倉庫を多数保有していることから、物流・輸送業であることがわかります。',
};

const Q31 = {
  id: 31,
  number: '31番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：会議室一覧',
  scene: '会議室予約',
  audioScript: 'この表は4つの会議室の収容人数と設備を示しています。「明日、30名の研修を行いたい。プロジェクターと音響設備の両方が必要です」という条件で、どの会議室が適切かを考えてください。',
  material: {
    type: 'table',
    title: '会議室一覧',
    content: [
      ['部屋名', '収容人数', 'プロジェクター', '音響設備'],
      ['第1会議室', '20名', '✓', '✗'],
      ['第2会議室', '40名', '✓', '✗'],
      ['第3会議室', '15名', '✗', '✓'],
      ['大ホール', '100名', '✓', '✓']
    ]
  },
  question: '30名・プロジェクター・音響設備の条件を満たす会議室はどれですか。',
  options: ['第1会議室', '第2会議室', '第3会議室', '大ホール'],
  answer: 3,
  explanation: '大ホールのみが、30名以上の収容力（100名）、プロジェクター・音響設備の3条件を全て満たしています。第2会議室は人数・プロジェクターは満たしますが音響設備がありません。',
};

const Q32 = {
  id: 32,
  number: '32番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：新入社員困りごとランキング',
  scene: '新入社員の悩み調査',
  audioScript: 'このグラフは、新入社員が最初の1年間で困ったことのランキングです。1位「仕事の進め方がわからない」2位「敬語・ビジネスマナー」3位「人間関係」4位「残業・長時間労働」という結果でした。',
  material: {
    type: 'table',
    title: '新入社員が困ったこと（1年以内）',
    content: [
      ['順位', '内容', '割合'],
      ['1位', '仕事の進め方がわからない', '52%'],
      ['2位', '敬語・ビジネスマナー', '38%'],
      ['3位', '人間関係（上司・同僚）', '29%'],
      ['4位', '残業・長時間労働', '21%']
    ]
  },
  question: 'このデータから言えることとして最も適切なものはどれですか。',
  options: ['新入社員の最大の悩みは残業の多さだ', '業務の進め方に関する困惑が最も多くの新入社員に共通している', '敬語・マナーに困る新入社員はほとんどいない', '人間関係の悩みが残業より少ない新入社員はいない'],
  answer: 1,
  explanation: '1位の「仕事の進め方がわからない」が52%と最多です。残業は4位（21%）で最少、敬語・マナーは38%と2番目に多い。',
};

const Q33 = {
  id: 33,
  number: '33番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：クラウドサービス料金表',
  scene: 'クラウドサービス料金計算',
  audioScript: 'この料金表を見ながら、「5名でスタンダードプランを3ヶ月利用した場合の合計金額はいくらになるか」という問いに答えてください。',
  material: {
    type: 'table',
    title: 'クラウドサービス料金表',
    content: [
      ['プラン', '月額/1アカウント', '最低契約期間'],
      ['ベーシック', '2,000円', '1ヶ月'],
      ['スタンダード', '3,500円', '3ヶ月'],
      ['プレミアム', '6,000円', '12ヶ月'],
      ['※5アカウント以上は10%割引適用', '', '']
    ]
  },
  question: '5名でスタンダードプランを3ヶ月利用した場合の合計金額はいくらですか。',
  options: ['52,500円', '45,500円', '47,250円', '63,000円'],
  answer: 2,
  explanation: '3,500円×5名×3ヶ月＝52,500円。5アカウント以上は10%割引なので52,500×0.9＝47,250円になります。',
};

const Q34 = {
  id: 34,
  number: '34番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：季節別売上パターン',
  scene: '商品売上季節変動',
  audioScript: 'このグラフは4つの商品の月別売上を示しています。商品Aは安定して高い売上を維持、商品Bは冬に急増、商品Cは年間を通して低水準、商品Dは夏にピークを迎えるという特徴があります。',
  material: {
    type: 'table',
    title: '季節別売上パターン（概略）',
    content: [
      ['商品', '春', '夏', '秋', '冬', '特徴'],
      ['商品A', '高', '高', '高', '高', '安定'],
      ['商品B', '低', '低', '中', '高', '冬需要型'],
      ['商品C', '低', '低', '低', '低', '低水準'],
      ['商品D', '中', '高', '中', '低', '夏需要型']
    ]
  },
  question: '夏に売上が最も高くなる商品はどれですか。',
  options: ['商品A', '商品B', '商品C', '商品D'],
  answer: 3,
  explanation: '商品Dは「夏需要型」で夏にピークを迎えます。商品Aは常に高いが季節変動なし。商品Bは冬型、商品Cは通年低水準です。',
};

const Q35 = {
  id: 35,
  number: '35番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：社内メール',
  scene: '社員旅行アンケート協力依頼',
  audioScript: 'このメールを読んで、送信者が受信者に何をしてほしいかを考えてください。',
  material: {
    type: 'email',
    title: '社内メール',
    content: '差出人：総務部　高橋\n宛先：全社員\n件名：【回答期限：3/10】社員旅行アンケートのご協力のお願い\nお疲れ様です。総務部の高橋です。\n今年度の社員旅行の計画立案にあたり、希望の行き先・時期・予算感についてアンケートを実施します。\n下記URLよりご回答ください。所要時間は約3分です。\n回答期限：3月10日（月）17:00まで\nご協力のほど、よろしくお願いいたします。'
  },
  question: 'このメールで送信者が求めていることは何ですか。',
  options: ['社員旅行への参加申し込み', '旅行の幹事への立候補', 'アンケートへの回答', '旅行費用の事前振り込み'],
  answer: 2,
  explanation: 'メールは「アンケートのご協力のお願い」が件名で、「下記URLよりご回答ください」と明記されています。まだ計画段階であり、申し込みではありません。',
};

const Q36 = {
  id: 36,
  number: '36番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：市場シェア推移',
  scene: '競合企業市場シェア比較',
  audioScript: 'このグラフはA社とB社の過去5年間の市場シェアの推移を示しています。5年前はA社60%・B社25%でしたが、現在はA社45%・B社40%となっており、差が縮まっています。',
  material: {
    type: 'table',
    title: '市場シェア推移',
    content: [
      ['年', 'A社', 'B社', '差'],
      ['5年前', '60%', '25%', '35ポイント'],
      ['3年前', '55%', '30%', '25ポイント'],
      ['現在', '45%', '40%', '5ポイント']
    ]
  },
  question: 'このグラフから読み取れる正しい傾向はどれですか。',
  options: ['A社のシェアは一貫して増加している', 'B社はA社との差を縮め続けている', '現在B社のシェアはA社を上回っている', '5年前A社とB社のシェアは同じだった'],
  answer: 1,
  explanation: '差は35→25→5ポイントと縮小しており、B社がA社との差を着実に縮めています。現在はまだA社45%がB社40%を上回っています。',
};

const Q37 = {
  id: 37,
  number: '37番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：個人情報管理ポスター',
  scene: '社内セキュリティ啓発',
  audioScript: 'このポスターはどのような目的で作られたものか考えてください。対象者と行動を促す内容に注目してください。',
  material: {
    type: 'poster',
    title: 'ポスター',
    content: '個人情報の取り扱いに注意！\n✖ 社外で顧客情報を話すのはNG\n✖ USBへの無断コピーは禁止\n✖ 離席時のPC画面は必ずロック\n✖ メールの誤送信に注意\n情報漏洩は会社・お客様への重大な損害になります\n情報管理部'
  },
  question: 'このポスターの目的は何ですか。',
  options: ['社員に個人情報の適切な管理を促す', '顧客に個人情報の提供を求める', '新しい情報システムの使い方を説明する', '個人情報保護法の内容を説明する'],
  answer: 0,
  explanation: '社員向けに「社外で話すのはNG」「USBへの無断コピー禁止」などの注意事項を提示し、個人情報の適切な管理を促す社内ポスターです。',
};

const Q38 = {
  id: 38,
  number: '38番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：プロジェクトスケジュール',
  scene: 'ソフトウェア開発プロジェクト',
  audioScript: 'このプロジェクトスケジュール表を見て、「設計フェーズが完了する月はいつか」という質問に答えてください。',
  material: {
    type: 'table',
    title: 'プロジェクトスケジュール',
    content: [
      ['フェーズ', '開始', '終了', '担当'],
      ['要件定義', '4月', '5月', '営業・企画'],
      ['設計', '6月', '8月', '開発部'],
      ['開発・実装', '9月', '11月', '開発部'],
      ['テスト', '12月', '1月', 'QA部'],
      ['リリース', '2月', '—', '全部門']
    ]
  },
  question: '設計フェーズが完了するのはいつですか。',
  options: ['5月', '6月', '8月', '9月'],
  answer: 2,
  explanation: '表より設計フェーズは6月開始・8月終了です。6月は開始月、9月は開発・実装の開始月です。',
};

const Q39 = {
  id: 39,
  number: '39番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：ビジネススキル調査',
  scene: '企業人事担当者スキル調査',
  audioScript: 'このグラフはビジネスパーソンが重要視するスキルの調査結果です。1位「コミュニケーション能力」68%、2位「専門知識・技術」54%、3位「問題解決力」48%、4位「語学力」32%、5位「リーダーシップ」27%という結果でした。',
  material: {
    type: 'table',
    title: 'ビジネスに必要なスキル（企業人事担当者調査）',
    content: [
      ['順位', 'スキル', '重要視する割合'],
      ['1', 'コミュニケーション能力', '68%'],
      ['2', '専門知識・技術', '54%'],
      ['3', '問題解決力', '48%'],
      ['4', '語学力', '32%'],
      ['5', 'リーダーシップ', '27%']
    ]
  },
  question: 'このデータについて正しい説明はどれですか。',
  options: ['人事担当者が最も重視するのはコミュニケーション能力だ', '語学力はリーダーシップより重要視されていない', '過半数がリーダーシップを最重要と考えている', '専門知識より問題解決力を重視する企業が多い'],
  answer: 0,
  explanation: 'コミュニケーション能力が68%で1位です。語学力32%はリーダーシップ27%より高い（2は誤り）。専門知識54%は問題解決力48%より高い（4は誤り）。',
};

const Q40 = {
  id: 40,
  number: '40番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '資料聴読解：4社決算比較',
  scene: '企業財務分析',
  audioScript: 'このグラフは4社の昨年度決算を比較したものです。売上高はP社が最大、Q社が最小です。しかし経常利益率を見ると、P社は5%に対してR社は12%と高い収益性を示しています。S社は売上高は2番目に大きいが、経常損益が赤字です。',
  material: {
    type: 'table',
    title: '4社決算比較',
    content: [
      ['会社', '売上高', '経常利益率', '経常損益'],
      ['P社', '1,000億', '5%', '黒字'],
      ['Q社', '200億', '8%', '黒字'],
      ['R社', '600億', '12%', '黒字'],
      ['S社', '800億', '—', '赤字']
    ]
  },
  question: 'この4社の中で最も収益性が高い会社はどこですか。',
  options: ['P社', 'Q社', 'R社', 'S社'],
  answer: 2,
  explanation: '収益性（経常利益率）が最も高いのはR社の12%です。P社は売上が最大でも利益率は5%。S社は赤字です。売上高の大きさ≠収益性の高さに注意が必要です。',
};

// ─────────────────────────────────────────
// Section 3：総合聴読解問題 Q41~Q60
// ─────────────────────────────────────────

const Q41 = {
  id: 41,
  number: '41番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：式次第変更',
  scene: '創立30周年記念式典',
  audioScript: '男の人と女の人がイベントのプログラムについて話しています。\n男：社長の挨拶なんですが、最初に持ってきても冒頭から重くなるかなと思って。\n女：そうですね。来賓の方のスピーチが終わったあとに入れると、流れが良さそうです。\n男：じゃあ、③の来賓スピーチの直後、④の記念品贈呈の前に変更しましょう。\n女：賛成です。そうしましょう。',
  material: {
    type: 'program',
    title: '式次第（変更前）',
    content: [
      ['①', '開会の辞'],
      ['②', '社長挨拶　← 現在の位置'],
      ['③', '来賓スピーチ'],
      ['④', '記念品贈呈'],
      ['⑤', '閉会の辞']
    ]
  },
  question: '変更後、社長挨拶はプログラムのどこに入りますか。',
  options: [
    '①開会→②社長挨拶→③来賓→④記念品→⑤閉会（変更なし）',
    '①開会→②来賓→③社長挨拶→④記念品→⑤閉会',
    '①開会→②来賓→③記念品→④社長挨拶→⑤閉会',
    '①開会→②来賓→③記念品→④閉会（社長挨拶を削除）'
  ],
  answer: 1,
  explanation: '「③来賓スピーチの直後、④記念品贈呈の前」という会話から、来賓スピーチ→社長挨拶→記念品贈呈の順番になります。',
};

const Q42 = {
  id: 42,
  number: '42番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：見積書変更',
  scene: 'プリンター購入見積もり',
  audioScript: '営業担当者と顧客が見積書について話しています。\n顧客：この見積書なんですが、数量は問題ないです。単価についても了解しています。\n営業：ありがとうございます。\n顧客：ただ、納期が少し遅くて、もう2週間早めていただけますか。\n営業：承知しました。では納期を変更いたします。支払条件については現状のままでよろしいでしょうか。\n顧客：はい、それはこのままで大丈夫です。',
  material: {
    type: 'quote',
    title: '見積書',
    content: [
      ['① 品名', '業務用プリンター Model-X'],
      ['② 数量', '5台'],
      ['③ 単価', '85,000円'],
      ['④ 納期', '注文から8週間後'],
      ['⑤ 支払条件', '納品後30日以内']
    ]
  },
  question: '営業担当者が変更する項目はどれですか。',
  options: ['① 品名', '② 数量', '④ 納期', '⑤ 支払条件'],
  answer: 2,
  explanation: '顧客が「2週間早めてほしい」と要望し、営業担当者が「納期を変更します」と応答しました。数量・単価・支払条件は変更なしです。',
};

const Q43 = {
  id: 43,
  number: '43番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：システム操作',
  scene: '申請書送信',
  audioScript: '社員が電話で話しています。\n男：山本さん、今出先にいるんですが、システムに申請書を送ってほしいんです。\n女：わかりました。フォルダを開きましたが、どのボタンを使えばいいですか。\n男：まず「新規作成」ではなく、既存のファイルを「添付」して送ってください。\n女：「添付」ですね。それでどこに送ればいいですか。\n男：「送信」ボタンを押せば自動的に私のアドレスに届きます。「保存」は押さなくていいです。',
  material: {
    type: 'buttons',
    title: 'システム画面のボタン',
    content: ['① 新規作成', '② 添付', '③ 保存', '④ 送信']
  },
  question: '女の人が最初に押すボタンはどれですか。',
  options: ['① 新規作成', '② 添付', '③ 保存', '④ 送信'],
  answer: 1,
  explanation: '男性が「新規作成ではなく、既存ファイルを添付して送ってください」と指示しており、女性がまず押すのは「添付」ボタンです。',
};

const Q44 = {
  id: 44,
  number: '44番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：チラシデザイン選択',
  scene: '店舗チラシデザイン',
  audioScript: '店長と社員がチラシのデザインについて話しています。\n店長：4つのデザイン案があるんだけど、どれがいいと思う？\n社員：写真が入っているものの方が目を引くと思います。\n店長：じゃあ①か③だね。\n社員：①は文字が多すぎて読みにくいです。③の方がシンプルで見やすいと思います。\n店長：確かに。じゃあ③にしよう。',
  material: {
    type: 'designs',
    title: 'チラシデザイン案4種',
    content: [
      '① LOGO（大）・白抜き文字・紺背景',
      '② LOGO（小）・黒文字・白背景',
      '③ LOGO（大）・黒文字・白背景・読みやすい',
      '④ ロゴなし・シンプル・テキストのみ'
    ]
  },
  question: '選ばれたデザインはどれですか。',
  options: ['① ロゴ大・白抜き文字', '② ロゴ小・黒文字', '③ ロゴ大・黒文字・読みやすい', '④ ロゴなし'],
  answer: 2,
  explanation: '「写真が入っている→①か③」「①は文字が多すぎる→③の黒文字・ロゴ大が採用」という選択プロセスです。',
};

const Q45 = {
  id: 45,
  number: '45番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：出席者リスト変更',
  scene: '経営会議出席者',
  audioScript: '二人が会議の出席者リストについて話しています。\n女：来週の経営会議の出席者リストを確認したいんですが。\n男：はい。このリストなんですが、田中部長が出張になったので欠席になります。\n女：そうですか。代わりに誰かが出席しますか。\n男：田中部長の代わりに、鈴木課長が出席します。\n女：わかりました。佐藤取締役は？\n男：佐藤取締役はご出席いただきます。リストの田中部長の欄を鈴木課長に変更してください。',
  material: {
    type: 'list',
    title: '経営会議出席者リスト',
    content: [
      ['社長', '山田 一郎', '出席'],
      ['営業部長', '田中 二郎 → 鈴木 三郎（課長）に変更', ''],
      ['取締役', '佐藤 四郎', '出席'],
      ['財務部長', '高橋 五郎', '出席']
    ]
  },
  question: 'リストで変更が必要なのはどの欄ですか。',
  options: ['社長の欄', '営業部長（田中部長）の欄', '取締役（佐藤）の欄', '財務部長の欄'],
  answer: 1,
  explanation: '田中部長が出張のため欠席となり、代わりに鈴木課長が出席するため、田中部長の欄を変更します。佐藤取締役は出席のまま変更不要です。',
};

const Q46 = {
  id: 46,
  number: '46番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：注文書変更',
  scene: 'オフィス用品注文',
  audioScript: '社員が電話でオフィス用品の注文について話しています。\n社員：注文書を確認したんですが、コピー用紙のA4が10箱になっていますが、実際は5箱で足ります。\n業者：承知しました。5箱に変更しますね。他はいかがでしょうか。\n社員：ボールペンの黒は20本のままで、赤は追加で10本加えてください。\n業者：赤のボールペンを10本追加ですね。ファイルはいかがですか。\n社員：ファイルは注文書通りで大丈夫です。',
  material: {
    type: 'order',
    title: '注文書（変更前）',
    content: [
      ['コピー用紙A4', '10箱 → 5箱に変更'],
      ['ボールペン（黒）', '20本　変更なし'],
      ['ボールペン（赤）', '0本 → 10本追加'],
      ['A4ファイル', '30冊　変更なし']
    ]
  },
  question: '注文書で変更・追加が必要なものはどれですか。（2つ）',
  options: ['コピー用紙A4とボールペン（黒）', 'ボールペン（黒）とボールペン（赤）', 'コピー用紙A4とボールペン（赤）', 'ボールペン（赤）とA4ファイル'],
  answer: 2,
  explanation: 'コピー用紙A4を10箱→5箱に減らし、赤ボールペンを10本追加。黒ボールペンとファイルは変更なしです。',
};

const Q47 = {
  id: 47,
  number: '47番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：座席配置',
  scene: 'セミナーVIP席配置',
  audioScript: '二人が座席表について話しています。\n男：来月のセミナーの座席表ですが、VIPのお客様をどこに配置しますか。\n女：前方の席が良いと思いますが、最前列は講師に近すぎますね。\n男：では2列目はいかがですか。中央の席にしましょう。\n女：そこなら動線も良さそうですね。右側が出入口に近いので、左側の中央がいいと思います。\n男：わかりました。では2列目の左中央の席にご案内します。',
  material: {
    type: 'seating',
    title: '会場座席図（前方部分）',
    content: [
      ['列', '左', '中央', '右（出入口側）'],
      ['1列目（最前）', 'A1', 'A2', 'A3'],
      ['2列目', 'B1', 'B2 ★', 'B3'],
      ['3列目', 'C1', 'C2', 'C3']
    ]
  },
  question: 'VIPのお客様が案内される席はどれですか。',
  options: ['A2（1列目・中央）', 'B3（2列目・右）', 'B2（2列目・左中央）', 'C1（3列目・左）'],
  answer: 2,
  explanation: '「最前列は近すぎる→2列目」「右は出入口→左側」「中央」という条件から、2列目・左中央のB2席です。',
};

const Q48 = {
  id: 48,
  number: '48番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：配送追跡操作',
  scene: '荷物追跡システム',
  audioScript: '担当者が配送の問い合わせを受けています。\n顧客：先日注文した荷物の追跡をしたいんですが。\n担当：追跡番号を入力すれば状況が確認できます。画面を見ながらご説明します。\n顧客：わかりました。\n担当：まず「荷物追跡」のタブをクリックして、次に追跡番号を入力するボックスに番号を入れてください。「検索」ボタンは押さないで、「追跡開始」ボタンを押してください。\n顧客：「追跡開始」ですね。わかりました。',
  material: {
    type: 'system',
    title: '配送追跡システム画面',
    content: [
      'タブ：ホーム | 荷物追跡 | お問合せ',
      '追跡番号：[入力ボックス]',
      'ボタン：① 検索 | ② 追跡開始 | ③ クリア | ④ 印刷'
    ]
  },
  question: '顧客が追跡番号を入力した後に押すボタンはどれですか。',
  options: ['① 検索', '② 追跡開始', '③ クリア', '④ 印刷'],
  answer: 1,
  explanation: '担当者が「検索ボタンは押さないで、追跡開始ボタンを押してください」と明示しています。',
};

const Q49 = {
  id: 49,
  number: '49番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：名刺デザイン選択',
  scene: '会社名刺デザイン',
  audioScript: '二人が名刺のデザインについて話しています。\n男：4種類の名刺デザイン案がありますが、どれがいいですか。\n女：会社のロゴが大きく入っているものが好ましいですね。\n男：では①か③ですね。\n女：①は文字が白抜きで読みにくいです。③は黒文字で読みやすく、ロゴも目立つのでいいと思います。\n男：わかりました。では③に決めましょう。',
  material: {
    type: 'designs',
    title: '名刺デザイン案4種',
    content: [
      '① LOGO（大）・白抜き文字・紺背景',
      '② LOGO（小）・黒文字・白背景',
      '③ LOGO（大）・黒文字・白背景・読みやすい',
      '④ ロゴなし・シンプル・テキストのみ'
    ]
  },
  question: '選ばれた名刺のデザインはどれですか。',
  options: ['① ロゴ大・白抜き文字', '② ロゴ小・黒文字', '③ ロゴ大・黒文字・読みやすい', '④ ロゴなし'],
  answer: 2,
  explanation: '「ロゴが大きい→①か③」「①は白抜きで読みにくい→③の黒文字・ロゴ大が採用」という選択プロセスです。',
};

const Q50 = {
  id: 50,
  number: '50番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：契約書変更',
  scene: '業務委託契約',
  audioScript: '担当者が契約書の内容変更について話しています。\n男：契約書の内容について確認させてください。契約期間は問題ないですね。\n女：はい、1年間のままで大丈夫です。\n男：契約金額についてはどうですか。\n女：先日のご提案の金額より10%下げていただけると助かるのですが。\n男：10%ですか。少し難しいですが…5%の値引きなら可能です。\n女：わかりました、では5%で。自動更新の条件は現状のままで。\n男：はい。では契約金額のみ変更して、改めて送付します。',
  material: {
    type: 'contract',
    title: '契約書（主要項目）',
    content: [
      ['① 契約期間', '1年間（変更なし）'],
      ['② 契約金額', '→ 5%値引き後の金額に変更'],
      ['③ 自動更新', 'あり（変更なし）'],
      ['④ 支払い方法', '月払い（変更なし）']
    ]
  },
  question: '変更される契約の項目はどれですか。',
  options: ['① 契約期間', '② 契約金額', '③ 自動更新', '④ 支払い方法'],
  answer: 1,
  explanation: '5%値引きに合意し、「契約金額のみ変更して改めて送付する」と男性が明言しています。他の項目は全て変更なしです。',
};

const Q51 = {
  id: 51,
  number: '51番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：コピー機操作',
  scene: '両面コピー操作',
  audioScript: '社員がコピー機の操作について説明を受けています。\n先輩：このコピー機、両面コピーをする時はちょっと手順が違うんです。\n新人：教えていただけますか。\n先輩：まず原稿をセットして、パネルの「両面」ボタンを押します。次にカラーか白黒を選ぶんですが、今日は「白黒」でいいですか。\n新人：はい、白黒で大丈夫です。\n先輩：白黒を選んだら、枚数を入力して、最後に「スタート」を押してください。「プレビュー」は押さなくていいです。',
  material: {
    type: 'buttons',
    title: 'コピー機操作パネル',
    content: ['① カラー', '② 白黒', '③ 両面', '④ プレビュー', '⑤ スタート']
  },
  question: '新人社員が押すボタンの正しい順番はどれですか。',
  options: ['①カラー→③両面→⑤スタート', '③両面→①カラー→⑤スタート', '③両面→②白黒→⑤スタート', '③両面→④プレビュー→⑤スタート'],
  answer: 2,
  explanation: '手順は「両面ボタン→カラーか白黒を選ぶ（今回は白黒）→枚数入力→スタート」です。プレビューは不要と言われました。',
};

const Q52 = {
  id: 52,
  number: '52番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：レストラン選択',
  scene: 'ランチミーティング会場',
  audioScript: '二人がランチミーティングの場所について話しています。\n男：ランチミーティングの会場なんですが、4つ候補があります。\n女：個室があるところがいいですね。話し合いがしやすいので。\n男：個室があるのはBとDですね。Bは駅から徒歩10分です。\n女：少し遠いですね。Dはどうですか。\n男：Dは駅から2分で、和食なんですが。\n女：和食でも全然いいですよ。予算は問題ないですか。\n男：Dはランチセット3,000円です。予算内です。\n女：じゃあDにしましょう。',
  material: {
    type: 'restaurants',
    title: 'レストラン候補リスト',
    content: [
      ['店', '個室', '駅距離', '料理', 'ランチ予算'],
      ['A', '✗', '1分', 'イタリアン', '2,000円'],
      ['B', '✓', '10分', 'フレンチ', '4,000円'],
      ['C', '✗', '3分', '中華', '1,800円'],
      ['D', '✓', '2分', '和食', '3,000円']
    ]
  },
  question: '選ばれたレストランはどれですか。',
  options: ['A（個室なし・駅近・イタリアン）', 'B（個室あり・駅から遠い・フレンチ）', 'C（個室なし・中華）', 'D（個室あり・駅近・和食）'],
  answer: 3,
  explanation: '条件は「個室あり」→B・D、「駅から近い」→D（2分）に絞り込み。料理・予算も問題なしでDに決定。',
};

const Q53 = {
  id: 53,
  number: '53番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：採用スケジュール変更',
  scene: '新卒採用プロセス',
  audioScript: '人事部の社員が採用スケジュールについて話しています。\n男：新卒採用のスケジュールを確認したいんですが。書類選考は4月に実施する予定ですね。\n女：はい。ただ、1次面接が5月から6月に変更になりました。\n男：そうですか。では最終面接は？\n女：最終面接は変わらず7月のままです。内定通知も8月のままですが、入社は4月ですね。\n男：わかりました。変更は1次面接だけということですね。',
  material: {
    type: 'schedule',
    title: '採用スケジュール',
    content: [
      ['選考ステップ', '当初予定', '変更後'],
      ['書類選考', '4月', '変更なし'],
      ['1次面接', '5月', '6月（変更）'],
      ['最終面接', '7月', '変更なし'],
      ['内定通知', '8月', '変更なし'],
      ['入社', '翌年4月', '変更なし']
    ]
  },
  question: 'スケジュールで変更になったのはどのステップですか。',
  options: ['書類選考', '1次面接', '最終面接', '内定通知'],
  answer: 1,
  explanation: '「変更は1次面接だけ」と明言されており、5月から6月に変更されました。他のステップは全て当初予定通りです。',
};

const Q54 = {
  id: 54,
  number: '54番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：メールシステム操作',
  scene: '一斉メール送信',
  audioScript: '社員がメールシステムの操作について教えてもらっています。\n新人：メールを複数の人に一斉送信したいんですが、どうすればいいですか。\n先輩：「新規作成」ではなくて、「一斉送信」のボタンを使います。\n新人：このボタンですか。\n先輩：そうです。押すと送信先リストが表示されます。「全員選択」を押してから「送信実行」を押してください。「プレビュー確認」は任意なので、今回は省略していいです。\n新人：「一斉送信」→「全員選択」→「送信実行」ですね。',
  material: {
    type: 'buttons',
    title: 'メールシステム画面',
    content: ['① 新規作成', '② 一斉送信', '③ 全員選択', '④ プレビュー確認', '⑤ 送信実行']
  },
  question: '使用するボタンの正しい順番はどれですか。',
  options: ['①→③→⑤', '②→④→⑤', '②→③→⑤', '①→②→⑤'],
  answer: 2,
  explanation: '「一斉送信→全員選択→送信実行」という手順を新人自身が最後に確認しています。プレビュー確認は省略可能です。',
};

const Q55 = {
  id: 55,
  number: '55番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：オフィスレイアウト変更',
  scene: 'プリンター配置変更',
  audioScript: '二人が社内のレイアウト変更について話しています。\n男：オフィスのレイアウト変更ですが、新しいプリンターをどこに置きますか。\n女：現在は営業部のエリアの角にありますが、全部署が使いやすいように中央付近がいいですよね。\n男：でも中央は会議スペースがあります。\n女：では会議スペースの隣、受付に一番近い壁際はどうでしょう。\n男：そこなら動線も良さそうですね。決まりました。',
  material: {
    type: 'layout',
    title: 'オフィスフロアマップ（簡略）',
    content: [
      ['受付', '★プリンター設置場所', '営業部'],
      ['エントランス', '会議スペース', '営業部'],
      ['総務部', '開発部', '現プリンター位置']
    ]
  },
  question: '新しいプリンターはどこに置かれることになりましたか。',
  options: ['営業部エリアの角（現在の場所）', '受付に最も近い会議スペースの隣', 'オフィスの中央（会議スペース）', '総務部エリア'],
  answer: 1,
  explanation: '「中央は会議スペースがある→会議スペースの隣、受付に一番近い壁際」という流れで決定しました。',
};

const Q56 = {
  id: 56,
  number: '56番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：請求書修正',
  scene: '会社名漢字誤記',
  audioScript: '担当者が請求書の修正について話しています。\n顧客：先日届いた請求書なんですが、会社名の漢字が一字間違っていて。「株式会社山本商事」なんですが、「山」が「川」になっています。\n担当：大変失礼しました。会社名を修正した請求書を再送します。金額と振込先は正しいですか。\n顧客：金額と振込先は合っています。支払い期限も確認しました、正しいです。\n担当：承知しました。会社名のみ修正して再送いたします。',
  material: {
    type: 'invoice',
    title: '請求書（誤記あり）',
    content: [
      ['① 宛先会社名', '株式会社川本商事（誤）→ 山本商事（正）'],
      ['② 請求金額', '¥550,000（税込）　正しい'],
      ['③ 振込先', '○○銀行 △△支店　正しい'],
      ['④ 支払期限', '2024年4月30日　正しい']
    ]
  },
  question: '修正が必要な項目はどれですか。',
  options: ['① 宛先会社名', '② 請求金額', '③ 振込先', '④ 支払期限'],
  answer: 0,
  explanation: '「川本」→「山本」への修正のみ必要です。金額・振込先・支払期限は顧客が全て正しいと確認しました。',
};

const Q57 = {
  id: 57,
  number: '57番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：福利厚生パンフレット',
  scene: '育児休業制度確認',
  audioScript: '二人が福利厚生のパンフレットを見ながら話しています。\n新人：育児休業は何歳まで取得できますか。\n先輩：パンフレットを見てください。子どもが3歳になるまでですね。\n新人：在宅勤務は週何日まで認められていますか。\n先輩：週3日までですね。ただし部署によって異なる場合もあると書いてあります。\n新人：有給休暇は入社何年目から取得できますか。\n先輩：入社6ヶ月後から10日間付与されます。',
  material: {
    type: 'benefits',
    title: '福利厚生パンフレット（抜粋）',
    content: [
      ['育児休業', '子どもが3歳になるまで取得可'],
      ['在宅勤務', '週3日まで（部署により異なる場合あり）'],
      ['有給休暇', '入社6ヶ月後から10日間付与']
    ]
  },
  question: '育児休業はいつまで取得できますか。',
  options: ['子どもが1歳になるまで', '子どもが3歳になるまで', '子どもが6歳になるまで', '入社から3年間'],
  answer: 1,
  explanation: 'パンフレットにも会話にも「子どもが3歳になるまで」と明記されています。',
};

const Q58 = {
  id: 58,
  number: '58番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：納品書確認',
  scene: 'オフィス家具納品',
  audioScript: '二人が納品書の確認をしています。\n男：届いた荷物の中身を納品書と照合してください。\n女：はい。まずデスクチェアが3脚ということで…実際は3脚ありますね。\n男：ファイルキャビネットは？\n女：2台のはずが、1台しかありません。\n男：それは不足ですね。ホワイトボードは？\n女：1枚届いています。一致しています。\n男：では、ファイルキャビネット1台が不足しているということで業者に連絡します。',
  material: {
    type: 'delivery',
    title: '納品書',
    content: [
      ['品目', '納品数', '実際の到着数', '状況'],
      ['デスクチェア', '3脚', '3脚', '✓ 一致'],
      ['ファイルキャビネット', '2台', '1台', '✗ 不足'],
      ['ホワイトボード', '1枚', '1枚', '✓ 一致']
    ]
  },
  question: '納品書と実際の到着数が一致していないのはどれですか。',
  options: ['デスクチェア', 'ファイルキャビネット', 'ホワイトボード', '全品目が一致している'],
  answer: 1,
  explanation: '2台の予定が1台しか届いておらず、1台不足しています。他の品目は一致確認済みです。',
};

const Q59 = {
  id: 59,
  number: '59番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：来客応対フロー',
  scene: 'VIPお客様対応',
  audioScript: '二人が来客応対について話しています。\n先輩：来週、大切なお客様が来られます。応対の手順を確認しておきましょう。\n新人：はい、よろしくお願いします。\n先輩：まず受付でお名前を確認してご案内します。次に会議室にご案内して、お茶をお出しします。担当者への連絡は、会議室へのご案内の前に行ってください。\n新人：では「受付→担当者へ連絡→会議室ご案内→お茶」の順ですか。\n先輩：そうです。よく覚えておいてください。',
  material: {
    type: 'flow',
    title: '来客応対フロー（4ステップ）',
    content: [
      '① 受付・名前確認',
      '② 担当者へ連絡',
      '③ 会議室へご案内',
      '④ お茶を出す'
    ]
  },
  question: '来客応対の正しい手順はどれですか。',
  options: ['受付→会議室→担当者連絡→お茶', '受付→担当者連絡→会議室→お茶', '担当者連絡→受付→会議室→お茶', '受付→お茶→担当者連絡→会議室'],
  answer: 1,
  explanation: '「担当者への連絡は会議室へのご案内の前に」という指示と、新人の確認「受付→担当者へ連絡→会議室ご案内→お茶」が正解です。',
};

const Q60 = {
  id: 60,
  number: '60番',
  type: 'listeningReading',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '総合聴読解：月次報告書フォーマット変更',
  scene: '報告書フォーマット見直し',
  audioScript: '部長と社員が報告書のフォーマットについて話しています。\n部長：月次報告書のフォーマットを見直したいんですが、現状の項目で不要なものはありますか。\n社員：「担当者所感」の欄は、毎月ほぼ同じ内容になっているので削除してもいいかもしれません。\n部長：確かに。あと、「翌月の行動計画」はKPI達成状況と別にありますが、統合できますか。\n社員：はい、「KPI達成状況」に「翌月計画」を含める形にすれば、1項目削減できます。\n部長：では「担当者所感」の削除と、「翌月の行動計画」の統合の2点を変更しましょう。',
  material: {
    type: 'format',
    title: '月次報告書フォーマット（変更前）',
    content: [
      ['① 売上実績', '変更なし'],
      ['② KPI達成状況', '← 翌月計画と統合'],
      ['③ 担当者所感', '← 削除'],
      ['④ 翌月の行動計画', '← ②に統合・削除'],
      ['⑤ 添付資料一覧', '変更なし']
    ]
  },
  question: 'フォーマットから削除または統合される項目はどれですか。',
  options: ['①売上実績と②KPI達成状況', '②KPI達成状況と③担当者所感', '③担当者所感のみ', '③担当者所感（削除）と④翌月の行動計画（②に統合）'],
  answer: 3,
  explanation: '「担当者所感の削除」と「翌月の行動計画のKPI達成状況への統合」という2点の変更が決まりました。売上実績・KPI達成状況（本体）・添付資料は変更なしです。',
};

// 导出所有题目
export const listeningReadingQuestions = [
  Q1, Q2, Q3, Q4, Q5, Q6, Q7, Q8, Q9, Q10,
  Q11, Q12, Q13, Q14, Q15, Q16, Q17, Q18, Q19, Q20,
  Q21, Q22, Q23, Q24, Q25, Q26, Q27, Q28, Q29, Q30,
  Q31, Q32, Q33, Q34, Q35, Q36, Q37, Q38, Q39, Q40,
  Q41, Q42, Q43, Q44, Q45, Q46, Q47, Q48, Q49, Q50,
  Q51, Q52, Q53, Q54, Q55, Q56, Q57, Q58, Q59, Q60
];
